// Auto-generated by npm run build:tokens — do not edit manually.
import { definePreset } from '@primeuix/themes';
import { Core } from './core.preset';

export const MitsuiPreset = definePreset(Core, {
  primitive: {
    brandindigo: {
      '50': '#F4F6FF',
      '75': '#ECEDF5',
      '100': '#E5E9FA',
      '200': '#C7CDEF',
      '300': '#A0AADE',
      '400': '#7582C4',
      '500': '#27348B',
      '600': '#222E7D',
      '700': '#1C2568',
      '800': '#171F57',
      '900': '#111741',
      '950': '#0A0E29'
    },
    brandcyan: {
      '300': '#55CCFF',
      '400': '#0F8FD6',
      '500': '#009FE3',
      '600': '#0077B3',
      '700': '#0073AD',
      '800': '#006699'
    }
  },
  semantic: {
    primary: {
      '50': '{brandindigo.50}',
      '100': '{brandindigo.100}',
      '200': '{brandindigo.200}',
      '300': '{brandindigo.300}',
      '400': '{brandindigo.400}',
      '500': '{brandindigo.500}',
      '600': '{brandindigo.600}',
      '700': '{brandindigo.700}',
      '800': '{brandindigo.800}',
      '900': '{brandindigo.900}',
      '950': '{brandindigo.950}'
    },
    colorScheme: {
      light: {
        surface: {
          '0': '#ffffff',
          '50': '{slate.50}',
          '100': '{slate.100}',
          '200': '{slate.200}',
          '300': '{slate.300}',
          '400': '{slate.400}',
          '500': '{slate.500}',
          '600': '{slate.600}',
          '700': '{slate.700}',
          '800': '{slate.800}',
          '900': '{slate.900}',
          '950': '{slate.950}'
        },
        highlight: {
          background: '{primary.50}',
          focusBackground: '{primary.100}',
          color: '{primary.700}',
          focusColor: '{primary.800}'
        },
        formField: {
          background: '{surface.0}',
          borderColor: '{surface.300}',
          hoverBorderColor: '{surface.400}',
          focusBorderColor: '{primary.color}',
          color: '{surface.700}',
          placeholderColor: '{surface.500}',
          iconColor: '{surface.400}'
        },
        text: {
          color: '{surface.700}',
          hoverColor: '{surface.800}',
          mutedColor: '{surface.500}',
          hoverMutedColor: '{surface.600}'
        },
        content: {
          background: '{surface.0}',
          hoverBackground: '{surface.100}',
          borderColor: '{surface.200}',
          color: '{text.color}',
          hoverColor: '{text.hover.color}'
        },
        overlay: {
          select: {
            background: '{surface.0}',
            borderColor: '{surface.200}',
            color: '{text.color}'
          },
          popover: {
            background: '{surface.0}',
            borderColor: '{surface.200}',
            color: '{text.color}'
          },
          modal: {
            background: '{surface.0}',
            borderColor: '{surface.200}',
            color: '{text.color}'
          }
        },
        list: {
          option: {
            focusBackground: '{surface.100}',
            selectedBackground: '{highlight.background}',
            selectedFocusBackground: '{highlight.focus.background}',
            color: '{text.color}',
            focusColor: '{text.hover.color}',
            selectedColor: '{highlight.color}',
            selectedFocusColor: '{highlight.focus.color}',
            icon: {
              color: '{surface.400}',
              focusColor: '{surface.500}'
            }
          }
        },
        navigation: {
          item: {
            focusBackground: '{surface.100}',
            activeBackground: '{surface.100}',
            color: '{text.color}',
            focusColor: '{text.hover.color}',
            activeColor: '{text.hover.color}',
            icon: {
              color: '{surface.400}',
              focusColor: '{surface.500}',
              activeColor: '{surface.500}'
            }
          }
        },
        primary: {
          color: '{brandindigo.500}',
          contrastColor: '#ffffff',
          hoverColor: '{brandindigo.600}',
          activeColor: '{brandindigo.700}'
        }
      },
      dark: {
        surface: {
          '0': '#ffffff',
          '50': '{zinc.50}',
          '100': '{zinc.100}',
          '200': '{zinc.200}',
          '300': '{zinc.300}',
          '400': '{zinc.400}',
          '500': '{zinc.500}',
          '600': '{zinc.600}',
          '700': '{zinc.700}',
          '800': '{zinc.800}',
          '900': '{zinc.900}',
          '950': '{zinc.950}'
        },
        highlight: {
          background: 'color-mix(in srgb, {primary.400}, transparent 84%)',
          focusBackground: 'color-mix(in srgb, {primary.400}, transparent 76%)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)'
        },
        formField: {
          background: '{surface.950}',
          borderColor: '{surface.600}',
          hoverBorderColor: '{surface.500}',
          focusBorderColor: '{primary.color}',
          color: '{surface.0}',
          placeholderColor: '{surface.400}',
          iconColor: '{surface.400}'
        },
        text: {
          color: '{surface.0}',
          hoverColor: '{surface.0}',
          mutedColor: '{surface.400}',
          hoverMutedColor: '{surface.300}'
        },
        content: {
          background: '{surface.900}',
          hoverBackground: '{surface.800}',
          borderColor: '{surface.700}',
          color: '{text.color}',
          hoverColor: '{text.hover.color}'
        },
        overlay: {
          select: {
            background: '{surface.900}',
            borderColor: '{surface.700}',
            color: '{text.color}'
          },
          popover: {
            background: '{surface.900}',
            borderColor: '{surface.700}',
            color: '{text.color}'
          },
          modal: {
            background: '{surface.900}',
            borderColor: '{surface.700}',
            color: '{text.color}'
          }
        },
        list: {
          option: {
            focusBackground: '{surface.800}',
            selectedBackground: '{highlight.background}',
            selectedFocusBackground: '{highlight.focus.background}',
            color: '{text.color}',
            focusColor: '{text.hover.color}',
            selectedColor: '{highlight.color}',
            selectedFocusColor: '{highlight.focus.color}',
            icon: {
              color: '{surface.500}',
              focusColor: '{surface.400}'
            }
          }
        },
        navigation: {
          item: {
            focusBackground: '{surface.800}',
            activeBackground: '{surface.800}',
            color: '{text.color}',
            focusColor: '{text.hover.color}',
            activeColor: '{text.hover.color}',
            icon: {
              color: '{surface.500}',
              focusColor: '{surface.400}',
              activeColor: '{surface.400}'
            }
          }
        },
        glass: {
          bg: 'rgba(13, 20, 51, 0.34)',
          borderColor: 'rgba(255, 255, 255, 0.18)',
          borderColorHover: '#55CCFF'
        },
        bgGradient:
          'linear-gradient(115deg, #1B2470 0%, #22318C 38%, #1668B8 78%, #0F8FD6 100%)',
        primary: {
          color: '{brandindigo.400}',
          contrastColor: '{surface.900}',
          hoverColor: '{brandindigo.300}',
          activeColor: '{brandindigo.200}'
        }
      }
    }
  },
  extend: {
    action: {
      link: {
        light: {
          default: '{brandcyan.600}',
          hover: '{brandcyan.700}',
          active: '{brandcyan.800}'
        },
        dark: {
          default: '{brandcyan.500}',
          hover: '{brandcyan.500}',
          active: '{brandcyan.500}'
        }
      }
    }
  },
  components: {
    button: {
      colorScheme: {
        light: {
          link: {
            color: '{action.link.light.default}',
            hoverColor: '{action.link.light.hover}',
            activeColor: '{action.link.light.active}'
          },
          root: {
            danger: {
              background: '{red.600}',
              hoverBackground: '{red.700}',
              activeBackground: '{red.800}',
              borderColor: '{red.600}',
              hoverBorderColor: '{red.700}',
              activeBorderColor: '{red.800}',
              color: '{surface.0}',
              hoverColor: '{surface.0}',
              activeColor: '{surface.0}',
              focusRing: {
                color: '{red.600}',
                shadow: 'none'
              }
            },
            success: {
              color: '{green.950}',
              hoverColor: '{green.950}',
              activeColor: '{green.950}'
            },
            warn: {
              color: '{orange.950}',
              hoverColor: '{orange.950}',
              activeColor: '{orange.950}'
            },
            info: {
              color: '{sky.950}',
              hoverColor: '{sky.950}',
              activeColor: '{sky.950}'
            }
          }
        },
        dark: {
          link: {
            color: '{action.link.dark.default}',
            hoverColor: '{action.link.dark.hover}',
            activeColor: '{action.link.dark.active}'
          },
          root: {
            danger: {
              background: '{red.500}',
              hoverBackground: '{red.400}',
              activeBackground: '{red.300}',
              borderColor: '{red.500}',
              hoverBorderColor: '{red.400}',
              activeBorderColor: '{red.300}',
              color: '{red.950}',
              hoverColor: '{red.950}',
              activeColor: '{red.950}',
              focusRing: {
                color: '{red.500}',
                shadow: 'none'
              }
            },
            info: {
              color: '{sky.950}',
              hoverColor: '{sky.950}',
              activeColor: '{sky.950}'
            }
          }
        }
      }
    },
    badge: {
      colorScheme: {
        light: {
          danger: {
            background: '{red.600}',
            color: '{surface.0}'
          }
        },
        dark: {
          danger: {
            background: '{red.500}',
            color: '{red.950}'
          }
        }
      }
    },
    message: {
      colorScheme: {
        light: {
          info: {
            background: '{sky.50}',
            borderColor: '{sky.200}',
            color: '{sky.700}',
            closeButton: {
              focusRing: {
                color: '{sky.700}',
                shadow: 'none'
              }
            },
            outlined: {
              color: '{sky.700}',
              borderColor: '{sky.700}'
            },
            simple: {
              color: '{sky.700}'
            }
          },
          success: {
            background: '{green.50}',
            borderColor: '{green.200}',
            color: '{green.700}',
            closeButton: {
              focusRing: {
                color: '{green.700}',
                shadow: 'none'
              }
            },
            outlined: {
              color: '{green.700}',
              borderColor: '{green.700}'
            },
            simple: {
              color: '{green.700}'
            }
          },
          warn: {
            background: '{orange.50}',
            borderColor: '{orange.200}',
            color: '{orange.700}',
            closeButton: {
              focusRing: {
                color: '{orange.700}',
                shadow: 'none'
              }
            },
            outlined: {
              color: '{orange.700}',
              borderColor: '{orange.700}'
            },
            simple: {
              color: '{orange.700}'
            }
          },
          error: {
            background: '{red.50}',
            borderColor: '{red.200}',
            color: '{red.700}',
            closeButton: {
              focusRing: {
                color: '{red.700}',
                shadow: 'none'
              }
            },
            outlined: {
              color: '{red.700}',
              borderColor: '{red.700}'
            },
            simple: {
              color: '{red.700}'
            }
          }
        },
        dark: {
          info: {
            background: '{sky.900}',
            borderColor: '{sky.700}',
            color: '{sky.300}',
            closeButton: {
              focusRing: {
                color: '{sky.300}',
                shadow: 'none'
              }
            },
            outlined: {
              color: '{sky.300}',
              borderColor: '{sky.300}'
            },
            simple: {
              color: '{sky.300}'
            }
          },
          success: {
            background: '{green.900}',
            borderColor: '{green.700}',
            color: '{green.300}',
            closeButton: {
              focusRing: {
                color: '{green.300}',
                shadow: 'none'
              }
            },
            outlined: {
              color: '{green.300}',
              borderColor: '{green.300}'
            },
            simple: {
              color: '{green.300}'
            }
          },
          warn: {
            background: '{orange.900}',
            borderColor: '{orange.700}',
            color: '{orange.300}',
            closeButton: {
              focusRing: {
                color: '{orange.300}',
                shadow: 'none'
              }
            },
            outlined: {
              color: '{orange.300}',
              borderColor: '{orange.300}'
            },
            simple: {
              color: '{orange.300}'
            }
          },
          error: {
            background: '{red.900}',
            borderColor: '{red.700}',
            color: '{red.300}',
            closeButton: {
              focusRing: {
                color: '{red.300}',
                shadow: 'none'
              }
            },
            outlined: {
              color: '{red.300}',
              borderColor: '{red.300}'
            },
            simple: {
              color: '{red.300}'
            }
          }
        }
      }
    },
    toast: {
      colorScheme: {
        light: {
          info: {
            background: '{sky.50}',
            borderColor: '{sky.200}',
            color: '{sky.700}',
            detailColor: '{surface.700}',
            closeButton: {
              focusRing: {
                color: '{sky.700}',
                shadow: 'none'
              }
            }
          },
          success: {
            background: '{green.50}',
            borderColor: '{green.200}',
            color: '{green.700}',
            detailColor: '{surface.700}',
            closeButton: {
              focusRing: {
                color: '{green.700}',
                shadow: 'none'
              }
            }
          },
          warn: {
            background: '{orange.50}',
            borderColor: '{orange.200}',
            color: '{orange.700}',
            detailColor: '{surface.700}',
            closeButton: {
              focusRing: {
                color: '{orange.700}',
                shadow: 'none'
              }
            }
          },
          error: {
            background: '{red.50}',
            borderColor: '{red.200}',
            color: '{red.700}',
            detailColor: '{surface.700}',
            closeButton: {
              focusRing: {
                color: '{red.700}',
                shadow: 'none'
              }
            }
          }
        },
        dark: {
          info: {
            background: '{sky.900}',
            borderColor: '{sky.700}',
            color: '{sky.300}',
            detailColor: '{surface.0}',
            closeButton: {
              focusRing: {
                color: '{sky.300}',
                shadow: 'none'
              }
            }
          },
          success: {
            background: '{green.900}',
            borderColor: '{green.700}',
            color: '{green.300}',
            detailColor: '{surface.0}',
            closeButton: {
              focusRing: {
                color: '{green.300}',
                shadow: 'none'
              }
            }
          },
          warn: {
            background: '{orange.900}',
            borderColor: '{orange.700}',
            color: '{orange.300}',
            detailColor: '{surface.0}',
            closeButton: {
              focusRing: {
                color: '{orange.300}',
                shadow: 'none'
              }
            }
          },
          error: {
            background: '{red.900}',
            borderColor: '{red.700}',
            color: '{red.300}',
            detailColor: '{surface.0}',
            closeButton: {
              focusRing: {
                color: '{red.300}',
                shadow: 'none'
              }
            }
          }
        }
      }
    }
  }
});
